module.exports = __webpack_public_path__ + "media/assets/images/events/mkithp_interview-15e791982321ce26595671868dd84500.jpg";